// SEO Landing Pages - Local/Industry SEO for FlexiTech

export const seoPages = [
  {
    id: "it-support-medical-centres-australia",
    title: "IT Support for Medical Centres in Australia",
    icon: "Stethoscope",
    intro: "FlexiTech provides reliable, secure, and responsive IT support for medical centres and healthcare practices across Australia. With over 20 years of experience, we understand the critical importance of system uptime, patient data security, and compliance in healthcare environments.",
    whyTitle: "Why Medical Centres Choose FlexiTech",
    whyPoints: [
      "Experience supporting GP clinics and allied health practices",
      "Fast response times to minimise downtime",
      "Secure systems to protect patient data",
      "Clear communication with practice managers and staff",
      "Local Australian-based IT support",
    ],
    servicesTitle: "Healthcare-Focused IT Services",
    services: [
      "Managed IT support & helpdesk",
      "Microsoft 365 & secure email support",
      "Server and clinical software support",
      "Active Directory & user access management",
      "Cybersecurity, MFA & endpoint protection",
      "Backup & disaster recovery",
      "Network & Wi-Fi reliability",
    ],
    complianceTitle: "Compliance & Security",
    complianceText: "We help medical practices maintain secure and compliant IT systems, reducing the risk of data breaches, ransomware, and system outages. Our team understands Australian healthcare privacy requirements and implements best-practice security controls to protect sensitive patient information.",
    ctaText: "Book a free consultation to discuss reliable IT support for your medical centre.",
    ctaButton: "Book a Free Consultation",
    metaTitle: "IT Support for Medical Centres in Australia | FlexiTech",
    metaDescription: "Professional IT support for medical centres and healthcare practices across Australia. 20+ years experience. Secure, compliant, and reliable. Contact FlexiTech today.",
  },
  {
    id: "it-support-law-firms-australia",
    title: "IT Support for Law Firms in Australia",
    icon: "Scale",
    intro: "Law firms rely on secure, stable, and confidential IT systems. FlexiTech provides professional IT support tailored to Australian law firms, helping protect sensitive client data while ensuring systems run smoothly.",
    whyTitle: "Why Law Firms Choose FlexiTech",
    whyPoints: [
      "Experience supporting legal practices",
      "Strong focus on data security and confidentiality",
      "Reliable access to files and email systems",
      "Proactive monitoring and maintenance",
      "Local Australian IT experts",
    ],
    servicesTitle: "Legal IT Services",
    services: [
      "Managed IT support",
      "Microsoft 365 & email migration",
      "Server & document management support",
      "Active Directory & access controls",
      "Cybersecurity & ransomware protection",
      "Secure backups & disaster recovery",
    ],
    complianceTitle: "Security & Confidentiality",
    complianceText: "Client confidentiality is paramount in legal practice. We implement robust security measures including encrypted communications, multi-factor authentication, secure remote access, and comprehensive data protection policies that meet the expectations of the Australian legal industry.",
    ctaText: "Talk to a local IT expert about IT support for your law firm.",
    ctaButton: "Talk to an IT Expert",
    metaTitle: "IT Support for Law Firms in Australia | FlexiTech",
    metaDescription: "Secure, reliable IT support for Australian law firms. Protect client data, ensure system uptime, and get proactive IT management. Contact FlexiTech.",
  },
  {
    id: "it-support-real-estate-agencies-australia",
    title: "IT Support for Real Estate Agencies in Australia",
    icon: "Building2",
    intro: "Real estate agencies depend on fast, reliable IT to manage listings, inspections, contracts, and communication. FlexiTech delivers dependable IT support that keeps your agency running without interruptions.",
    whyTitle: "Key Benefits",
    whyPoints: [
      "Reliable systems during peak business hours",
      "Fast issue resolution",
      "Secure access to data in-office and remotely",
      "Support for cloud-based platforms",
      "Local Australian IT support team",
    ],
    servicesTitle: "Real Estate IT Services",
    services: [
      "Managed IT support & helpdesk",
      "Microsoft 365 & email support",
      "Network & Wi-Fi optimisation",
      "Cloud services & remote access",
      "Cybersecurity & backups",
    ],
    complianceTitle: "Connectivity & Reliability",
    complianceText: "Your agents need to be connected everywhere — in the office, at home, or out at a property. We design and maintain IT systems that provide reliable connectivity across all your locations and devices, so your team can close deals without technology getting in the way.",
    ctaText: "Get reliable IT support for your real estate agency today.",
    ctaButton: "Get Reliable IT Support",
    metaTitle: "IT Support for Real Estate Agencies in Australia | FlexiTech",
    metaDescription: "Dependable IT support for Australian real estate agencies. Keep agents connected, systems reliable, and data secure. Contact FlexiTech today.",
  },
  {
    id: "small-business-it-support-australia",
    title: "Small Business IT Support in Australia",
    icon: "Briefcase",
    intro: "FlexiTech provides affordable, professional IT support for small businesses across Australia. We act as your trusted IT partner, handling everything from day-to-day support to long-term IT strategy.",
    whyTitle: "Why Small Businesses Trust FlexiTech",
    whyPoints: [
      "20+ years of experience",
      "Friendly, clear communication",
      "Predictable IT support costs",
      "Scalable services as you grow",
      "Local Australian-based team",
    ],
    servicesTitle: "Small Business IT Services",
    services: [
      "Managed IT support",
      "Microsoft 365 & email",
      "Server & cloud services",
      "Cybersecurity & backups",
      "Network support",
    ],
    complianceTitle: "Grow with Confidence",
    complianceText: "As your business grows, your IT needs change. FlexiTech provides scalable IT support that adapts to your business — from a team of 5 to a team of 50 and beyond. We help you plan ahead so technology never holds your business back.",
    ctaText: "Book a free IT consultation for your business.",
    ctaButton: "Book a Free Consultation",
    metaTitle: "Small Business IT Support in Australia | FlexiTech",
    metaDescription: "Affordable, professional IT support for small businesses in Australia. 20+ years experience. Proactive, reliable, and friendly service. Contact FlexiTech.",
  },
];
